module.exports = __webpack_public_path__ + "img/dots_rub_5.b13ebb34.png";